import React, { useState } from "react";
import AppContext from './AppContext';

const GlobalState = props => {

    const [locationName, setLocationName] = useState('');
    const [currencyType, setCurrencyType] = useState('');
    const [companyId, setCompanyId] = useState('')


    return (
        <AppContext.Provider
            value={{
                locationName: locationName,
                setLocationName: setLocationName,
                currencyType: currencyType,
                setCurrencyType: setCurrencyType,
                companyId: companyId,
                setCompanyId: setCompanyId,
            }}
        >
            {props.children}
        </AppContext.Provider>
    );
};

export default GlobalState;
